export const PUBLIC_API_PAGE = {
  TITLE: 'API',
  DESCRIPTION:
    'Crea y revoca las claves de API que tus integraciones usan para leer y modificar los datos de tu organización.',
  ENDPOINTS: {
    TITLE: 'Endpoints de la API pública',
    DESCRIPTION:
      'Activa o desactiva cada endpoint público para todas las organizaciones. Un endpoint desactivado responde 403.',
    SUPERADMINS_ONLY: 'Solo los superadmins pueden activar o desactivar endpoints',
    EMPTY: 'Aún no hay endpoints públicos',
    TOGGLE: (summary: string) => `Activar ${summary}`,
    UPDATED: 'Endpoint actualizado',
    COLUMNS: {
      METHOD: 'Método',
      PATH: 'Ruta',
      SUMMARY: 'Resumen',
      ENABLED: 'Activado',
    },
  },
  API_KEYS: {
    TITLE: 'Claves de API',
    CREATE: 'Crear clave',
    EDITORS_ONLY: 'Solo los editores pueden gestionar las claves de API',
    EMPTY: 'Aún no hay claves de API',
    NEVER: 'Nunca',
    REVOKE: 'Revocar',
    COLUMNS: {
      NAME: 'Nombre',
      OWNER: 'Propietario',
      PREFIX: 'Clave',
      CREATED: 'Creada',
      EXPIRES: 'Caduca',
      LAST_USED: 'Último uso',
      STATUS: 'Estado',
    },
    STATUS: {
      ACTIVE: 'Activa',
      REVOKED: 'Revocada',
      EXPIRED: 'Caducada',
    },
    CREATE_DIALOG: {
      TITLE: 'Crear clave de API',
      DESCRIPTION: 'Ponle el nombre de la integración que la usará',
      NAME: 'Nombre',
      NAME_PLACEHOLDER: 'Pipeline de CI',
      SUBMIT: 'Crear',
      CANCEL: 'Cancelar',
      CREATED_TITLE: 'Clave de API creada',
      WARNING: 'Copia esta clave ahora. No podrás volver a verla',
      COPY: 'Copiar clave',
      COPIED: 'Clave copiada',
      DONE: 'Hecho',
    },
    REVOKE_DIALOG: {
      TITLE: 'Revocar clave de API',
      DESCRIPTION: (name: string) => `Las integraciones que usan ${name} dejarán de funcionar de inmediato.`,
      CONFIRM: 'Revocar',
      CANCEL: 'Cancelar',
      REVOKED: 'Clave de API revocada',
    },
  },
}
